/* eslint-disable react/no-unused-prop-types */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DocumentsHeaderText from './DocumentHeaderText';
import { StyledSection, StyledPageMainTitle } from './DocumentsHeader.styles';

export interface DocumentsHeaderProps { }

const DocumentsHeader: FC<DocumentsHeaderProps> = () => {
  const { t } = useTranslation('Documents');

  return (
    <StyledSection>
      <StyledPageMainTitle>
        {t('title')}
      </StyledPageMainTitle>
      <DocumentsHeaderText />
    </StyledSection>
  );
};

export default DocumentsHeader;
